import React from 'react';
import { traitLabels, type TraitKey } from '../../constants/traits';

export function TraitBars({
  traits,
}: {
  traits: Record<TraitKey, number | null | undefined>;
}) {
  const getDisplayValue = (value: number | null | undefined): string => {
    if (typeof value === 'number' && Number.isFinite(value)) return String(value);
    return '—';
  };

  const getWidth = (value: number | null | undefined): string => {
    if (typeof value === 'number' && Number.isFinite(value)) {
      const clamped = Math.max(0, Math.min(100, Math.round(value)));
      return `${clamped}%`;
    }
    return '0%';
  };

  return (
    <div className="space-y-6">
      {traitLabels.map((trait) => (
        <div key={trait.key}>
          <div className="flex justify-between items-baseline mb-3">
            <span className="text-sm font-semibold text-[#291B4C]/60 uppercase tracking-wider">
              {trait.label}
            </span>
            <span className="text-2xl font-bold text-[#291B4C] tabular-nums">
              {getDisplayValue(traits[trait.key])}
            </span>
          </div>
          <div className="space-y-2">
            <div className="h-3 bg-[#291B4C]/5 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#291B4C] rounded-full"
                style={{ width: getWidth(traits[trait.key]) }}
              />
            </div>
            <div className="flex items-center justify-between text-[10px] text-[#291B4C]/50 font-semibold uppercase tracking-wider">
              <div className="flex items-center gap-1">
                <span>←</span>
                <span>{trait.leftLabel}</span>
              </div>
              <div className="flex items-center gap-1">
                <span>{trait.rightLabel}</span>
                <span>→</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
